import React, { useState, useEffect } from 'react'
import {
	validateNumericIfPresent,
	validateAlphaRequired,
	validateRequired,
	validateEmailIfPresent,
	validatePhoneNumberIfPresent,
	hasError,
	removeError,
	validateAlphaNumericRequired,
	validateZipCodeIfPresent,
	validateAddressRequired,
	validateAddressIfPresent,
	validateAlphaIfPresent,
	validateAlphaNumericIfPresent,
	validatePhoneCountryCode,
	validatePhoneNumber,

} from '../captureAwbUtils'
import CountryAutocomplete from '../../CountryAutocomplete'
import { AUTOCOMPLETE_TYPE_COUNTRY } from '../../../constants'
import { useTranslation } from 'react-i18next'
import MESSAGES from '../../../constants/Messages'
import { validateAlphaNumeric } from '../../UserManagement/userManagementUtil'
import CommonInput from '../../../common/Resusable/CommonInput'
import CountryCodeDropdown from '../../UserManagement/CountryCodeDropdown'
import { COUNTRY_CODES } from '../../../constants/countryCodes'
import { sort } from '../../../utils/common'
import { PrimaryButton, SecondaryButton } from "../../../common/Buttons";
import { Divider } from '../../../common/Divider'
import plusIcon from '../../../assets/images/plusDarkBlue.svg'
const ParticipantDetails = ({
	awbDetails,
	setAwbDetails,
	error,
	setError,
	showNotifyList,
	setShowNotifyList,
}) => {
	//for multilingual
	const { t, i18n } = useTranslation(['labels', 'errors'])
	const isJapanese = i18n.language === 'ja';
	console.log('isJapanese', isJapanese);

	let shipperDetails = awbDetails.shipperDetails
	let consigneeDetails = awbDetails.consigneeDetails

	const [phContryCode, setPhContryCode] = useState(shipperDetails.phContryCode || '+971');
	const [phoneNumber, setPhoneNumber] = useState(shipperDetails.telephoneNo || '');
	
	// const sortedCountryCodes = COUNTRY_CODES
	// 	.map(code => ({ id: code, code, label: code }))
	// 	.sort((a, b) => a.code.localeCompare(b.code));

	const [sortedCountryCodes, setSortedCountryCodes] = useState([]);

    useEffect(() => {
        setSortedCountryCodes(sort(COUNTRY_CODES))
    }, []);

	// Bindings for CommonInput
	const bindPhoneNumber = {
		value: phoneNumber,
		onChange: (e) => {
			setPhoneNumber(e.target.value);
			shipperDetails.telephoneNo = e.target.value;
			setAwbDetails((prevState) => ({
				...prevState,
				shipperDetails: {
					...shipperDetails,
					telephoneNo: e.target.value,
					phContryCode: phContryCode
				}
			}));
		}
	};

	const triggerPhoneCodeValidation = () => {
			validatePhoneCountryCode(phContryCode, phoneNumber, setError)
		}

	//console.log(awbDetails,'awbDetails')

	const [notifyList, setNotifyList] = useState(
		awbDetails.notifyList
			? awbDetails.notifyList
			: {
				notifyShipper: {
					checked: false,
				},
				notifyConsignee: {
					checked: false,
				},
				notifyOther: {
					checked: true,
					name: '',
					phContryCode:'',
					telephoneNo: '',
					email: '',
					address: '',
					city: '',
					country: '',
				},
			}
	)

	// useEffect(() => {
	// 	setAwbDetails((prevState) => ({
	// 		...prevState,
	// 		notifyList: notifyList,
	// 	}))
	// }, [notifyList])


	useEffect(() => {
		const fullPhone = notifyList.notifyOther?.telephoneNo || '';
		let code = '';
		let phone = '';

		if (fullPhone.includes('-')) {
			[code, phone] = fullPhone.split('-');
		} else {
			phone = fullPhone;
		}

		// Only update if phone needs to be split (avoid infinite loop)
		if (fullPhone.includes('-')) {
			setNotifyList((prevState) => {
				const updatedNotifyOther = {
					...prevState.notifyOther,
					telephoneNo: phone,
					phContryCode: { code },
				};

				const updatedNotifyList = {
					...prevState,
					notifyOther: updatedNotifyOther,
				};

				// Also update awbDetails here after splitting
				setAwbDetails((prevState) => ({
					...prevState,
					notifyList: updatedNotifyList,
				}));

				return updatedNotifyList;
			});
		} else {
			// If already split, just sync notifyList to awbDetails
			setAwbDetails((prevState) => ({
				...prevState,
				notifyList: notifyList,
			}));
		}
	}, [notifyList]);




	const handleNotify = (evnt) => {
		const key = evnt.target.id
		const isChecked = evnt.target.checked
		let details = {
			checked: isChecked,
		}
		setError((prevState) => ({
			...prevState,
			notifyList: '',
		}))
		if (key === 'notifyOther') {
			details = {
				checked: isChecked,
				name: '',
				telephoneNo: '',
				email: '',
			}
		} else if (key === 'notifyShipper') {
			if (
				isChecked &&
				shipperDetails.emailAddress.trim() === '' &&
				shipperDetails.telephoneNo.trim() === ''
			) {
				setError((prevState) => ({
					...prevState,
					notifyShipper: MESSAGES.SHIPPER_NOTIFICATION_MSG,
				}))
			} else {
				setError((prevState) => ({
					...prevState,
					notifyShipper: '',
				}))
			}
		} else if (key === 'notifyConsignee') {
			if (
				isChecked &&
				consigneeDetails.emailAddress.trim() === '' &&
				consigneeDetails.telephoneNo.trim() === ''
			) {
				setError((prevState) => ({
					...prevState,
					notifyConsignee: MESSAGES.CONSGN_NOTIFICATION_MSG,
				}))
			} else {
				setError((prevState) => ({
					...prevState,
					notifyConsignee: '',
				}))
			}
		}

		setNotifyList((prevState) => ({
			...prevState,
			[key]: details,
		}))
	}

	const handleShowNotificationDetails = () => {
		setShowNotifyList(!showNotifyList)
	}

	const setSelectedShipperCountry = (val) => {
		shipperDetails.countryCode = val
		setAwbDetails((prevState) => ({
			...prevState,
			shipperDetails: shipperDetails,
		}))
	}

	const setSelectedConsigneeCountry = (val) => {
		consigneeDetails.countryCode = val
		setAwbDetails((prevState) => ({
			...prevState,
			consigneeDetails: consigneeDetails,
		}))
	}

	const setSelectedNotifyListOtherCountry = (val) => {
		let notifyOther = notifyList.notifyOther
		notifyOther.country = val
		setNotifyList((prevState) => ({
			...prevState,
			notifyOther: notifyOther,
		}))
	}

	const [notifyPhCountryCode, setNotifyPhCountryCode] = useState(
		notifyList.notifyOther.phContryCode || '+971'
	);
	const [notifyPhoneNumber, setNotifyPhoneNumber] = useState(
		notifyList.notifyOther.telephoneNo || ''
	);

	const bindNotifyPhoneNumber = {
		value: notifyPhoneNumber,
		onChange: (e) => {
			setNotifyPhoneNumber(e.target.value);
			setNotifyList((prevState) => ({
				...prevState,
				notifyOther: {
					...prevState.notifyOther,
					telephoneNo: e.target.value,
					phContryCode: notifyPhCountryCode,
				},
			}));
		},
	};

	return (
	<div className='capture-awb-participant-details-section'>
		<div className='portal-row heading-section'>
			<div className='portal-row'>
				<div className='portal-col'>
					<label className='section-heading'>{t('CAPTURE_AWB.PAR_DTLS')}</label>
				</div>
			</div>			
		<div className='participant-details-wrapper'>
			<div className='portal-row shipper-section'>
				<div className='portal-row'>
			    <h5 className='section-sub-heading mt-0 mb-0'>{t('CAPTURE_AWB.SHP_DTLS')}</h5>
			    </div>
				<div className='shipper-details-section'>
					<div className='shipping-deparr-row'>
						{/* <div className=' form-row mt-4 mb-md-3 mb-2'> */}

						<div
							className={`form-group ${hasError('shipperName', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperName'
								name='shipperName'
								type='text'
								// className='form-item__field'
								label={t('CAPTURE_AWB.NAME')}
								maxLength='70'
								value={shipperDetails.name ? shipperDetails.name.toUpperCase() : ''}
								onChange={(e) => {
									shipperDetails.name = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(e.target.value, setError, 'shipperName', 'COMMON.NAME')
								}}
								aria-invalid={hasError('shipperName', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperName']
									? t(error['shipperName'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* <div
								className='col-12 form-item form-item--text'
								data-module='molecules/form-item/FormItem'
							>
								<label className='form-item__label' htmlFor='shipperName'>
									{t('COMMON.NAME')}
								</label>
								<input
									id='shipperName'
									name='shipperName'
									type='text'
									className='form-item__field'
									placeholder='Name'
									maxLength='70'
									value={shipperDetails.name ? shipperDetails.name.toUpperCase() : ''}
									onChange={(e) => {
										shipperDetails.name = e.target.value
										setAwbDetails((prevState) => ({
											...prevState,
											shipperDetails: shipperDetails,
										}))
									}}
									onBlur={(e) => {
										validateRequired(e.target.value, setError, 'shipperName', 'COMMON.NAME')
									}}
									aria-invalid={hasError('shipperName', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
								/>
								<span className='form-item__error'>
									{error && error['shipperName']
										? t(error['shipperName'], { ns: 'errors' })
										: ''}
								</span>
							</div> */}


						<div
							className={`form-group ${hasError('shipperAddress', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperAddress'
								name='shipperAddress'
								type='text'
								label={t('CAPTURE_AWB.ADDRS')}
								value={shipperDetails.address ? shipperDetails.address.toUpperCase() : ''}
								maxLength='70'
								onChange={(e) => {
									shipperDetails.address = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'shipperAddress',
										'COMMON.ADDRS'
									)
								}}
								aria-invalid={hasError('shipperAddress', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperAddress']
									? t(error['shipperAddress'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* <div className='form-row mt-md-4 mt-2 mb-md-3 mb-2'>
							<div
								className='col-12 form-item form-item--text'
								data-module='molecules/form-item/FormItem'
							>
								<label className='form-item__label' htmlFor='shipperAddress'>
									{t('COMMON.ADDRS')}
								</label>
								<input
									id='shipperAddress'
									name='shipperAddress'
									type='text'
									className='form-item__field'
									placeholder='Address'
									value={shipperDetails.address ? shipperDetails.address.toUpperCase() : ''}
									maxLength='70'
									onChange={(e) => {
										shipperDetails.address = e.target.value
										setAwbDetails((prevState) => ({
											...prevState,
											shipperDetails: shipperDetails,
										}))
									}}
									onBlur={(e) => {
										validateRequired(
											e.target.value,
											setError,
											'shipperAddress',
											t('COMMON.ADDRS')
										)
									}}
									aria-invalid={hasError('shipperAddress', error)}
									onFocus={(e) => {
										removeError(e, setError)
									}}
								/>
								<span className='form-item__error'>
									{error && error['shipperAddress']
										? t(error['shipperAddress'], { ns: 'errors' })
										: ''}
								</span>
							</div>
						</div> */}
					</div>

					<div className='shipping-deparr-row'>

						{/* <div className='form-row mt-md-4 mt-2 mb-md-3 mb-2'> */}

						<div
							className={`form-group ${hasError('shipperCity', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperCity'
								name='shipperCity'
								type='text'
								label={t('CAPTURE_AWB.CITY')}
								value={shipperDetails.city ? shipperDetails.city.toUpperCase() : ''}
								maxLength='70'
								onChange={(e) => {
									shipperDetails.city = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(e.target.value, setError, 'shipperCity', 'COMMON.CITY')
								}}
								aria-invalid={hasError('shipperCity', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperCity']
									? t(error['shipperCity'], { ns: 'errors' })
									: ''}
							/>
						</div>

						<div
							className={`form-group ${hasError('shipperState', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperState'
								name='shipperState'
								type='text'
								label={t('CAPTURE_AWB.STATE')}
								value={shipperDetails.state ? shipperDetails.state.toUpperCase() : ''}
								maxLength='70'
								onChange={(e) => {
									shipperDetails.state = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									validateAlphaIfPresent(e.target.value, setError, 'shipperState')
								}}
								aria-invalid={hasError('shipperState', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperState']
									? t(error['shipperState'], { ns: 'errors' })
									: ''}
							/>
						</div>


					</div>

					<div className='shipping-deparr-row'>
						<div
							className={`form-group common-autocomplete country-autocomplete-capture ${hasError('shipperCountry', error) ? "red-border" : ""
								}`}
						>
							<div className="p-float-label input-wrapper">
								<CountryAutocomplete
									autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.SHIPPER}
									selectedShipperCountry={shipperDetails.countryCode}
									selectedCosigneeCountry={consigneeDetails.countryCode}
									setSelectedShipperCountry={setSelectedShipperCountry}
									isMandatory={true}
									setError={setError}
								/>
								<label htmlFor="shipperCountry">
									{t("CAPTURE_AWB.CNTRY")}
								</label>
							</div>
							<span className="search-panel__errormsg">
								{error && error['shipperCountry']
									? t(error['shipperCountry'], { ns: 'errors' })
									: ''}
							</span>
						</div>

						<div
							className={`form-group ${hasError('shipperZipCode', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperZipCode'
								name='shipperZipCode'
								type='text'
								label={t('CAPTURE_AWB.ZIP_CODE')}
								value={shipperDetails.zipCode ? shipperDetails.zipCode.toUpperCase() : ''}
								maxLength='11'
								onChange={(e) => {
									shipperDetails.zipCode = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									validateZipCodeIfPresent(
										e.target.value,
										setError,
										'shipperZipCode'
									)
								}}
								aria-invalid={hasError('shipperZipCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperZipCode']
									? t(error['shipperZipCode'], { ns: 'errors' })
									: ''}
							/>
						</div>

					</div>
					<div className='shipping-deparr-row'>

						<div
							className={`form-group ${hasError('shipperAccountNumber', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperAccountNumber'
								name='shipperAccountNumber'
								type='text'
								label={t('CAPTURE_AWB.ACCNT_NO')}
								maxLength='14'
								value={shipperDetails.accountNumber ? shipperDetails.accountNumber.toUpperCase() : ''}
								onChange={(e) => {
									shipperDetails.accountNumber = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									// validateNumericIfPresent(
									// 	e.target.value,
									// 	setError,
									// 	'shipperAccountNumber'
									// )
								}}
								aria-invalid={hasError('shipperAccountNumber', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperAccountNumber']
									? t(error['shipperAccountNumber'], { ns: 'errors' })
									: ''}
							/>
						</div>

						{/* Replace the old telephone input with the following */}
						{/* <div className="combined-phone-input form group"
							data-module='molecules/form-item/FormItem'>
							<div
								className={` ${error && error['phContryCode'] ? 'red-border' : ''}`}
							>
								<CountryCodeDropdown
									id='phContryCode'
									name='phContryCode'
									countryCodes={sortedCountryCodes}
									userCountryCode={phContryCode}
									setCountryCode={(code) => {
										setPhContryCode(code);
										shipperDetails.phContryCode = code;
										setAwbDetails((prevState) => ({
											...prevState,
											shipperDetails: {
												...shipperDetails,
												phContryCode: code,
												telephoneNo: phoneNumber
											}
										}));
										triggerPhoneCodeValidation(code);
									}}
									triggerCodeValidation={triggerPhoneCodeValidation}
									setError={setError}
									removeError={removeError}
								/>
								<span className='form-item__error'>
									{error && error['phContryCode']
										? t(error['phContryCode'], { ns: 'errors' })
										: ''}
								</span>
							</div>
							<div className='form-group flex-grow-1'>
								<CommonInput
									type='text'
									id='phoneNumber'
									label={t('CREATEUSER.PHONE_NO')}
									{...bindPhoneNumber}
									className='form-item__field'
									maxLength='15'
									aria-invalid={hasError('phoneNumber', error)}
									onFocus={() => removeError('phoneNumber', setError)}
									onBlur={(e) => {
										validatePhoneNumber(
											phoneNumber,
											phContryCode,
											setError,
											error
										);
										// Also update shipperDetails on blur
										shipperDetails.telephoneNo = phoneNumber;
										shipperDetails.phContryCode = phContryCode;
										setAwbDetails((prevState) => ({
											...prevState,
											shipperDetails: {
												...shipperDetails,
												telephoneNo: phoneNumber,
												phContryCode: phContryCode
											}
										}));
									}}
									error={error && error['phoneNumber']
										? t(error['phoneNumber'], { ns: 'errors' })
										: ''}
								/>
							</div>
						</div> */}

						{/* <div className={`form-group awb-input-section`}>
							<CountryCodeDropdown
								id="phContryCode"
								name="phContryCode"
								countryCodes={sortedCountryCodes}
								userCountryCode={phContryCode}
								setCountryCode={(code) => {
									setPhContryCode(code);
									shipperDetails.phContryCode = code;
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: {
											...shipperDetails,
											phContryCode: code,
											telephoneNo: phoneNumber
										}
									}));
									triggerPhoneCodeValidation(code);
								}}
								triggerCodeValidation={triggerPhoneCodeValidation}
								setError={setError}
								removeError={removeError}
							/>

							<CommonInput
								type="text"
								id="phoneNumber"
								label={t('COMMON.TEL_HEAD')}
								{...bindPhoneNumber}
								className="form-item__field"
								maxLength="15"
								aria-invalid={hasError('shipperTelephone', error)}
								onFocus={(e) => removeError(e, setError)}
								onBlur={(e) => {
									validatePhoneNumber(
										phoneNumber,
										phContryCode,
										setError,
										error
									);
									// Also update shipperDetails on blur
									shipperDetails.telephoneNo = phoneNumber;
									shipperDetails.phContryCode = phContryCode;
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: {
											...shipperDetails,
											telephoneNo: phoneNumber,
											phContryCode: phContryCode
										}
									}));
								}}
								error={error && error['shipperTelephone']
									? t(error['shipperTelephone'], { ns: 'errors' })
									: ''}
								wrapperClassName={"awb-suffix"}
								isOnlyErrorBorder
							/>
						</div> */}

						<div className="combined-phone-input d-flex align-items-end" data-module="molecules/form-item/FormItem">
							<div
								className={`country-dropdown-wrapper ${error && error['phContryCode'] ? 'red-border' : ''}`}
							>
								<CountryCodeDropdown
									id="phContryCode"
									name="phContryCode"
									countryCodes={sortedCountryCodes}
									userCountryCode={shipperDetails.phContryCode?.code || ''}
									setCountryCode={(codeObj) => {
											setAwbDetails((prevState) => ({
												...prevState,
												shipperDetails: {
													...prevState.shipperDetails,
													phContryCode: codeObj
												}
											}));
											triggerPhoneCodeValidation(codeObj.code);
										}}
									triggerCodeValidation={triggerPhoneCodeValidation}
									setError={setError}
									removeError={removeError}
								/>
								<span className="form-item__error">
									{error && error['phContryCode']
										? t(error['phContryCode'], { ns: 'errors' })
										: ''}
								</span>
							</div>
							
							<div className="form-group flex-grow-1 phone-input-wrapper">
									<CommonInput
										id="shipperTelephone"
										name="shipperTelephone"
										type="text"
      								    label={t('CAPTURE_AWB.TEL_HEAD')}				
										maxLength={20}
										value={shipperDetails.telephoneNo ? shipperDetails.telephoneNo.toUpperCase() : ''}
										aria-invalid={hasError('shipperTelephone', error)}
										onChange={(e) => {
											const value = e.target.value;
											setAwbDetails((prevState) => ({
												...prevState,
												shipperDetails: {
													...prevState.shipperDetails,
													telephoneNo: value, // update phone number
												},
											}));
                                          }}
										onBlur={(e) => {
											const status = validatePhoneNumberIfPresent(
												e.target.value,
												setError,
												'shipperTelephone'
											);
											if (e.target.value !== '' && status) {
												setError((prevState) => ({
													...prevState,
													notifyShipper: '',
												}));
											}
										}}
										onFocus={(e) => {
											removeError(e, setError);
										}}
										error={
											error && error['shipperTelephone']
												? t(error['shipperTelephone'], { ns: 'errors' })
												: ''
										}
									/>
							</div>
						</div>

						{/* <div
							className={`form-group ${hasError('shipperTelephone', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperTelephone'
								name='shipperTelephone'
								type='text'
								label={t('COMMON.TEL_HEAD')}
								maxLength='20'
								value={shipperDetails.telephoneNo ? shipperDetails.telephoneNo.toUpperCase() : ''}
								onChange={(e) => {
									shipperDetails.telephoneNo = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									const status = validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'shipperTelephone'
									)
									if (e.target.value !== '' && status) {
										setError((prevState) => ({
											...prevState,
											notifyShipper: '',
										}))
									}
								}}
								aria-invalid={hasError('shipperTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperTelephone']
									? t(error['shipperTelephone'], { ns: 'errors' })
									: ''}
							/>
						</div> */}

					</div>

					<div className='shipping-deparr-row'>
						{/* <div className='form-row mt-md-4 mt-2 mb-md-3 mb-2'> */}
						<div
							className={`form-group ${hasError('shipperEmail', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='shipperEmail'
								name='shipperEmail'
								type='text'
								label={t('CAPTURE_AWB.EMAIL_HEAD')}
								maxLength='50'
								value={shipperDetails.emailAddress ? shipperDetails.emailAddress.toUpperCase() : ''}
								onChange={(e) => {
									shipperDetails.emailAddress = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										shipperDetails: shipperDetails,
									}))
								}}
								onBlur={(e) => {
									const status = validateEmailIfPresent(
										e.target.value,
										setError,
										'shipperEmail'
									)
									if (e.target.value !== '' && status) {
										setError((prevState) => ({
											...prevState,
											notifyShipper: '',
										}))
									}
								}}
								aria-invalid={hasError('shipperEmail', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['shipperEmail']
									? t(error['shipperEmail'], { ns: 'errors' })
									: ''}
							/>
						</div>

					</div>
				</div>
			</div>	
			<div className='portal-row'>
				<div className='consignee-section'>
				<label className='section-sub-heading mb-0 mt-0'>{t('CAPTURE_AWB.CON_DTLS')}</label>
				<div className='consignee-details-section'>
					<div className='shipping-deparr-row'>

						<div
							className={`form-group ${hasError('consigneeName', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeName'
								name='consigneeName'
								type='text'
								label={t('CAPTURE_AWB.NAME')}
								maxLength='70'
								value={consigneeDetails.name ? consigneeDetails.name.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.name = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'consigneeName',
										t('COMMON.NAME')
									)
								}}
								aria-invalid={hasError('consigneeName', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeName']
									? t(error['consigneeName'], { ns: 'errors' })
									: ''}
							/>
						</div>

						<div
							className={`form-group ${hasError('consigneeAddress', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeAddress'
								name='consigneeAddress'
								type='text'
								label={t('CAPTURE_AWB.ADDRS')}
								maxLength='70'
								value={consigneeDetails.address ? consigneeDetails.address.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.address = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'consigneeAddress',
										t('CAPTURE_AWB.ADDRS')
									)
								}}
								aria-invalid={hasError('consigneeAddress', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeAddress']
									? t(error['consigneeAddress'], { ns: 'errors' })
									: ''}
							/>
						</div>
					</div>
					<div className='shipping-deparr-row'>

						<div
							className={`form-group ${hasError('consigneeCity', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeCity'
								name='consigneeCity'
								type='text'
								label={t('CAPTURE_AWB.CITY')}
								maxLength='70'
								value={consigneeDetails.city ? consigneeDetails.city.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.city = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									validateRequired(
										e.target.value,
										setError,
										'consigneeCity',
										t('CAPTURE_AWB.CITY')
									)
								}}
								aria-invalid={hasError('consigneeCity', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeCity']
									? t(error['consigneeCity'], { ns: 'errors' })
									: ''}
							/>
						</div>

						<div
							className={`form-group ${hasError('consigneeState', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeState'
								name='consigneeState'
								type='text'
								label={t('CAPTURE_AWB.STATE')}
								maxLength='70'
								value={consigneeDetails.state ? consigneeDetails.state.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.state = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									validateAlphaIfPresent(
										e.target.value,
										setError,
										'consigneeState'
									)
								}}
								aria-invalid={hasError('consigneeState', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeState']
									? t(error['consigneeState'], { ns: 'errors' })
									: ''}
							/>
						</div>

					</div>
					<div className='shipping-deparr-row'>

						<div
							className={`form-group common-autocomplete country-autocomplete-capture ${hasError('consigneeCountry', error) ? "red-border" : ""
								}`}
						>
							<div className="p-float-label input-wrapper">
								<CountryAutocomplete
									autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.CONSIGNEE}
									selectedShipperCountry={shipperDetails.countryCode}
									selectedCosigneeCountry={consigneeDetails.countryCode}
									setSelectedCosigneeCountry={setSelectedConsigneeCountry}
									isMandatory={true}
									setError={setError}
								/>
								<label htmlFor="consigneeCountry">
									{t("CAPTURE_AWB.CNTRY")}
								</label>
							</div>
							<span className="search-panel__errormsg">
								{error && error['consigneeCountry']
									? t(error['consigneeCountry'], { ns: 'errors' })
									: ''}
							</span>
						</div>

						<div
							className={`form-group ${hasError('consigneeZipCode', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeZipCode'
								name='consigneeZipCode'
								type='text'
								label={t('CAPTURE_AWB.ZIP_CODE')}
								maxLength='11'
								value={consigneeDetails.zipCode ? consigneeDetails.zipCode.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.zipCode = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									validateZipCodeIfPresent(
										e.target.value,
										setError,
										'consigneeZipCode'
									)
								}}
								aria-invalid={hasError('consigneeZipCode', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeZipCode']
									? t(error['consigneeZipCode'], { ns: 'errors' })
									: ''}
							/>
						</div>
					</div>
					<div className='shipping-deparr-row'>

						<div
							className={`form-group ${hasError('consigneeAccountNumber', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeAccountNumber'
								name='consigneeAccountNumber'
								type='text'
								label={t('CAPTURE_AWB.ACCNT_NO')}
								maxLength='14'
								value={consigneeDetails.accountNumber ? consigneeDetails.accountNumber.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.accountNumber = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									// validateNumericIfPresent(
									// 	e.target.value,
									// 	setError,
									// 	'consigneeAccountNumber'
									// )
								}}
								aria-invalid={hasError('consigneeAccountNumber', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeAccountNumber']
									? t(error['consigneeAccountNumber'], { ns: 'errors' })
									: ''}
							/>
						</div>


								<div className="combined-phone-input d-flex align-items-end" data-module="molecules/form-item/FormItem">
									<div
										className={`country-dropdown-wrapper ${error && error['consigneePhContryCode'] ? 'red-border' : ''}`}
									>
										<CountryCodeDropdown
											id="consigneePhContryCode"
											name="consigneePhContryCode"
											countryCodes={sortedCountryCodes}
											userCountryCode={consigneeDetails.phContryCode?.code || ''}
											setCountryCode={(codeObj) => {
											setAwbDetails((prevState) => ({
												...prevState,
												consigneeDetails: {
													...prevState.consigneeDetails,
													phContryCode: codeObj
												}
											}));
											triggerPhoneCodeValidation(codeObj.code);
										}}

											triggerCodeValidation={triggerPhoneCodeValidation}
											setError={setError}
											removeError={removeError}
										/>
										<span className="form-item__error">
											{error && error['consigneePhContryCode']
												? t(error['consigneePhContryCode'], { ns: 'errors' })
												: ''}
										</span>
									</div>
									<div className="form-group flex-grow-1 phone-input-wrapper">
										<CommonInput
											id='consigneeTelephone'
											name='consigneeTelephone'
											type='text'
											label={t('CAPTURE_AWB.TEL_HEAD')}
											maxLength='20'
											value={consigneeDetails.telephoneNo ? consigneeDetails.telephoneNo.toUpperCase() : ''}
											// onChange={(e) => {
											// 	consigneeDetails.telephoneNo = e.target.value;
											// 	setAwbDetails((prevState) => ({
											// 		...prevState,
											// 		consigneeDetails: { ...consigneeDetails },
											// 	}));
											// }}
											onChange={(e) => {
												const value = e.target.value;
												setAwbDetails((prevState) => ({
													...prevState,
													consigneeDetails: {
														...prevState.consigneeDetails,
														telephoneNo: value, // update phone number
													},
												}));
											}}
											onBlur={(e) => {
												const status = validatePhoneNumberIfPresent(
													e.target.value,
													setError,
													'consigneeTelephone'
												);
												if (e.target.value !== '' && status) {
													setError((prevState) => ({
														...prevState,
														notifyConsignee: '',
													}));
												}
											}}
											aria-invalid={hasError('consigneeTelephone', error)}
											onFocus={(e) => {
												removeError(e, setError);
											}}
											error={error && error['consigneeTelephone']
												? t(error['consigneeTelephone'], { ns: 'errors' })
												: ''}
										/>
									</div>
								</div>


						{/* <div
							className={`form-group ${hasError('consigneeTelephone', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeTelephone'
								name='consigneeTelephone'
								type='text'
								label={t('COMMON.TEL_HEAD')}
								maxLength='20'
								value={consigneeDetails.telephoneNo ? consigneeDetails.telephoneNo.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.telephoneNo = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									const status = validatePhoneNumberIfPresent(
										e.target.value,
										setError,
										'consigneeTelephone'
									)
									if (e.target.value !== '' && status) {
										setError((prevState) => ({
											...prevState,
											notifyConsignee: '',
										}))
									}
								}}
								aria-invalid={hasError('consigneeTelephone', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeTelephone']
									? t(error['consigneeTelephone'], { ns: 'errors' })
									: ''}
							/>
						</div> */}

					</div>
					<div className='shipping-deparr-row'>
						<div
							className={`form-group ${hasError('consigneeEmail', error) ? "red-border" : ""
								}`}
						>
							<CommonInput
								id='consigneeEmail'
								name='consigneeEmail'
								type='text'
								label={t('CAPTURE_AWB.EMAIL_HEAD')}
								maxLength='50'
								value={consigneeDetails.emailAddress ? consigneeDetails.emailAddress.toUpperCase() : ''}
								onChange={(e) => {
									consigneeDetails.emailAddress = e.target.value
									setAwbDetails((prevState) => ({
										...prevState,
										consigneeDetails: consigneeDetails,
									}))
								}}
								onBlur={(e) => {
									const status = validateEmailIfPresent(
										e.target.value,
										setError,
										'consigneeEmail'
									)
									if (e.target.value !== '' && status) {
										setError((prevState) => ({
											...prevState,
											notifyConsignee: '',
										}))
									}
								}}
								aria-invalid={hasError('consigneeEmail', error)}
								onFocus={(e) => {
									removeError(e, setError)
								}}
								error={error && error['consigneeEmail']
									? t(error['consigneeEmail'], { ns: 'errors' })
									: ''}
							/>
						</div>

					</div>
				</div>
				</div>
			</div>
			{!showNotifyList && (
				<div className='portal-row'>
					<div className='justify-content-center'>
						<div className='portal-col d-flex additional-btn-box justify-content-center'>

								<button
									type="button"
									className={`secondary-button notification-btn d-flex align-items-center`}
									onClick={handleShowNotificationDetails}
								>
									<span className="add-new-house-plus-wrapper">
										<img
											src={plusIcon}
											alt={"Plus Icon"}
											className="add-new-house-plus-icon"
										/>
									</span>
									{t('CAPTURE_AWB.NOTIFICATION')}

								</button>

							{/* <SecondaryButton
								label={t('COMMON.NOTIFICATION')}
								onClick={handleShowNotificationDetails}
							/> */}
						</div>
					</div>
					{/* <div className='col-12 col-lg-8'>
						<button
							className='link'
							style={{ background: 'transparent' }}
							onClick={handleShowNotificationDetails}
						>
							{t('COMMON.NOTIFICATION')}
						</button>
					</div> */}
				</div>
			)}
			{showNotifyList && (
				<div className='notification-details'>
					<div className='form-row'>
						<div className='col-12 col-lg-8'>
							<label className='section-sub-heading mb-1'>
								{t('CAPTURE_AWB.NOTIFY')}
							</label>
						</div>
					</div>
					{/*<div className='form-row mb-3 mt-3'>
						<div className='col-12 col-lg-8'>
							<div className='form-row mt-3 pl-1'>
								<div className='col col-lg-auto custom-pr-5'>
									<div
										className='form-item form-item--checkbox '
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='notifyShipper'
											checked={notifyList.notifyShipper.checked}
											value={notifyList.notifyShipper.checked}
											type='checkbox'
											name='notifyShipper'
											className='form-item__field'
											onChange={handleNotify}
										/>
										<label htmlFor='notifyShipper' className='form-item__label'>
											{t('CAPTURE_AWB.SHIPPER')}
										</label>
									</div>
								</div>
								<div className='col col-lg-auto pl-2 custom-pr-5'>
									<div
										className='form-item form-item--checkbox '
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='notifyConsignee'
											checked={notifyList.notifyConsignee.checked}
											value={notifyList.notifyConsignee.checked}
											type='checkbox'
											name='notifyConsignee'
											className='form-item__field'
											onChange={handleNotify}
										/>
										<label
											htmlFor='notifyConsignee'
											className='form-item__label'
										>
											{t('CAPTURE_AWB.CONSIGNEE')}
										</label>
									</div>
								</div>
								<div className='col col-lg-auto pl-2 custom-pr-5'>
									<div
										className='form-item form-item--checkbox '
										data-module='molecules/form-item/FormItem'
									>
										<input
											id='notifyOther'
											checked={notifyList.notifyOther.checked}
											value={notifyList.notifyOther.checked}
											type='checkbox'
											name='notifyOther'
											className='form-item__field'
											onChange={handleNotify}
										/>
										<label htmlFor='notifyOther' className='form-item__label'>
											{t('CAPTURE_AWB.OTHER')}
										</label>
									</div>
								</div>
							</div>
							<div>
								<span className='form-item__error'>
									{error && error['notifyList']
										? t(error['notifyList'], { ns: 'errors' })
										: ''}
								</span>
								<span className='form-item__error'>
									{error && error['notifyShipper']
										? t(error['notifyShipper'], { ns: 'errors' })
										: ''}
								</span>
								<span className='form-item__error'>
									{error && error['notifyConsignee']
										? t(error['notifyConsignee'], { ns: 'errors' })
										: ''}
								</span>
							</div>
						</div>
			         </div>*/}
					 {notifyList && notifyList.notifyOther.checked && (
						<div className='notify-other-details mb-2'>
							{/*<div className='form-row mb-3 mt-3'>
								<div className='col-12 col-lg-8'>
									<h5 className='section-sub-heading pl-md-1 pl-0 mb-3'>
										{t('COMMON.DTLS')}
									</h5>
								</div>
							</div>*/}
							{/* <div className='form-row mt-3 mb-1'> */}

							<div className='shipping-deparr-row'>

								<div
									className={`form-group ${hasError('notifyName', error) ? "red-border" : ""
										}`}
								>
									<CommonInput
										id='notifyName'
										name='notifyName'
										type='text'
										label={t('CAPTURE_AWB.NAME')}
										maxLength='70'
										value={notifyList.notifyOther.name ? notifyList.notifyOther.name.toUpperCase() : ''}
										onChange={(e) => {
											let notifyOther = notifyList.notifyOther
											notifyOther.name = e.target.value
											setNotifyList((prevState) => ({
												...prevState,
												notifyOther: notifyOther,
											}))
										}}
										onBlur={(e) => {
											validateAlphaIfPresent(
												e.target.value,
												setError,
												'notifyName'
											)
										}}
										aria-invalid={hasError('notifyName', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
										error={error && error['notifyName']
											? t(error['notifyName'], { ns: 'errors' })
											: ''}
									/>
								</div>

								<div className="combined-phone-input d-flex align-items-end" data-module="molecules/form-item/FormItem">
									<div
										className={`country-dropdown-wrapper ${error && error['notifyPhContryCode'] ? 'red-border' : ''}`}
									>
										<CountryCodeDropdown
											id="notifyPhContryCode"
											name="notifyPhContryCode"
											countryCodes={sortedCountryCodes}
												userCountryCode={notifyList.notifyOther.phContryCode?.code || ''}
												setCountryCode={(codeObj) => {
													setNotifyList((prevState) => ({
														...prevState,
														notifyOther: {
															...prevState.notifyOther,
															phContryCode: codeObj,
														},
													}));
													triggerPhoneCodeValidation(codeObj.code);
												}}
											setError={setError}
											removeError={removeError}
										/>
										<span className="form-item__error">
											{error && error['notifyPhContryCode']
												? t(error['notifyPhContryCode'], { ns: 'errors' })
												: ''}
										</span>
									</div>
									<div className="form-group flex-grow-1 phone-input-wrapper">
										{/* <CommonInput
											type="text"
											id="notifyTelephone"
											label={t('COMMON.TEL_HEAD')}
											{...bindNotifyPhoneNumber}
											className="form-item__field"
											maxLength="20"
											aria-invalid={hasError('notifyTelephone', error)}
											onFocus={(e) => removeError(e, setError)}
											onBlur={(e) => {
												validatePhoneNumberIfPresent(
													notifyPhoneNumber,
													setError,
													'notifyTelephone'
												);
												// Also update notifyOther on blur
												setNotifyList((prevState) => ({
													...prevState,
													notifyOther: {
														...prevState.notifyOther,
														telephoneNo: notifyPhoneNumber,
														phContryCode: notifyPhCountryCode,
													},
												}));
											}}
											error={error && error['notifyTelephone']
												? t(error['notifyTelephone'], { ns: 'errors' })
												: ''}
										/> */}

											<CommonInput
												type="text"
												id="notifyTelephone"
												name="notifyTelephone"
												label={t('CAPTURE_AWB.TEL_HEAD')}
												maxLength={20}
												value={notifyList.notifyOther.telephoneNo ? notifyList.notifyOther.telephoneNo.toUpperCase() : ''}
												aria-invalid={hasError('notifyTelephone', error)}
												onChange={(e) => {
													let notifyOther = notifyList.notifyOther;
													notifyOther.telephoneNo = e.target.value;
													setNotifyList((prevState) => ({
														...prevState,
														notifyOther: { ...notifyOther },
													}));
												}}
												onBlur={(e) => {
													validatePhoneNumberIfPresent(
														e.target.value,
														setError,
														'notifyTelephone'
													);
												}}
												onFocus={(e) => {
													removeError(e, setError);
												}}
												error={
													error && error['notifyTelephone']
														? t(error['notifyTelephone'], { ns: 'errors' })
														: ''
												}
											/>
									</div>
								</div>

							</div>

							<div className={`shipping-deparr-row${isJapanese ? ' mb-3' : ''}`}>

								<div
									className={`form-group ${hasError('notifyEmail', error) ? "red-border" : ""
										}`}
								>
									<CommonInput
										id='notifyEmail'
										name='notifyEmail'
										type='text'
										label={t('CAPTURE_AWB.EMAIL_PLACEHOLDER')}
										maxLength='50'
										value={notifyList.notifyOther.email ? notifyList.notifyOther.email.toUpperCase() : ''}
										onChange={(e) => {
											let notifyOther = notifyList.notifyOther
											notifyOther.email = e.target.value
											setNotifyList((prevState) => ({
												...prevState,
												notifyOther: notifyOther,
											}))
										}}
										onBlur={(e) => {
											validateEmailIfPresent(
												e.target.value,
												setError,
												'notifyEmail'
											)
										}}
										aria-invalid={hasError('notifyEmail', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
										error={error && error['notifyEmail']
											? t(error['notifyEmail'], { ns: 'errors' })
											: ''}
									/>
								</div>

								<div
									className={`form-group ${hasError('notifyOtherAddress', error) ? "red-border" : ""
										}`}
								>
									<CommonInput
										id='notifyOtherAddress'
										name='notifyOtherAddress'
										type='text'
										label={t('CAPTURE_AWB.ADDRS')}
										maxLength='70'
										value={notifyList.notifyOther.address ? notifyList.notifyOther.address.toUpperCase() : ''}
										onChange={(e) => {
											let notifyOther = notifyList.notifyOther
											notifyOther.address = e.target.value
											setNotifyList((prevState) => ({
												...prevState,
												notifyOther: notifyOther,
											}))
										}}
										onBlur={(e) => {
											validateAddressIfPresent(
												e.target.value,
												setError,
												'notifyOtherAddress'
											)
										}}
										aria-invalid={hasError('notifyOtherAddress', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
										error={error && error['notifyOtherAddress']
											? t(error['notifyOtherAddress'], { ns: 'errors' })
											: ''}
									/>
								</div>

							</div>

							<div className='shipping-deparr-row'>
								<div
									className={`form-group ${hasError('notifyOtherCity', error) ? "red-border" : ""
										}`}
								>
									<CommonInput
										id='notifyOtherCity'
										name='notifyOtherCity'
										type='text'
										label={t('CAPTURE_AWB.CITY')}
										value={notifyList.notifyOther.city ? notifyList.notifyOther.city.toUpperCase() : ''}
										maxLength='70'
										onChange={(e) => {
											let notifyOther = notifyList.notifyOther
											notifyOther.city = e.target.value
											setNotifyList((prevState) => ({
												...prevState,
												notifyOther: notifyOther,
											}))
										}}
										onBlur={(e) => {
											validateAlphaIfPresent(e.target.value, setError, 'notifyOtherCity')
										}}
										aria-invalid={hasError('notifyOtherCity', error)}
										onFocus={(e) => {
											removeError(e, setError)
										}}
										error={error && error['notifyOtherCity']
											? t(error['notifyOtherCity'], { ns: 'errors' })
											: ''}
									/>
								</div>


								<div
									className={`form-group common-autocomplete country-autocomplete-capture ${hasError('notifyOtherCountry', error) ? "red-border" : ""
										}`}
								>
									<div className="p-float-label input-wrapper">
										<CountryAutocomplete
											autoCompleteType={AUTOCOMPLETE_TYPE_COUNTRY.CONSIGNEE}
											selectedShipperCountry={notifyList.notifyOther.country}
											selectedCosigneeCountry={notifyList.notifyOther.country}
											setSelectedCosigneeCountry={setSelectedNotifyListOtherCountry}
											isMandatory={false}
											setError={setError}
											fieldName='notifyOtherCountry'
										/>
										<label htmlFor="notifyOtherCountry">
											{t("CAPTURE_AWB.CNTRY")}
										</label>
									</div>
									<span className="search-panel__errormsg">
										{error && error['notifyOtherCountry']
											? t(error['notifyOtherCountry'], { ns: 'errors' })
											: ''}
									</span>
								</div>

							</div>


							<div>
								<span className='form-item__error'>
									{error && error['notifyOther']
										? t(error['notifyOther'], { ns: 'errors' })
										: ''}
								</span>
							</div>
						</div>
					)}
				</div>	
			)}
		</div>
		</div>
	</div>	
	)
}

export default ParticipantDetails
